/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgLaptop = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path d="M22 19v2H2v-2zM20 3v14H4V3zm-2 2H6v10h12z" fill="currentcolor" fillRule="evenodd" />
  </Icon>
);
export { SvgLaptop as Laptop };
